import { SearchInput } from "@finanedi.es/storybook"
import SwitchButtons from "common/components/SwitchButtons"
import useNearScreen from "common/hooks/useNearScreen"
import { debounce } from "lodash"
import { nanoid } from "nanoid"
import { forwardRef, useEffect, useMemo, useRef, useState } from "react"
import { Grid, Menu } from "react-feather"
import { useTranslation } from "react-i18next"
import "./articulosFilter.scss"

const GRID = "GRID"

const switchButtons = (t: $TSMigrationFixMe) => [
  {
    Icon: Grid,
    id: "GRID",
    tooltip: `${t("catalogos.idView.filter.switchGrid")}`,
  },
  {
    Icon: Menu,
    id: nanoid(),
    tooltip: `${t("catalogos.idView.filter.switchList")}`,
  },
]

const MAX_RESULT_COUNT = 20

const INITIAL_PRICE_MAX_RANGE = 100000000

const ArticulosFilter = forwardRef(
  (
    {
      // @ts-expect-error TS(2339): Property 'initialMinPrecioRange' does not exist on...
      initialMinPrecioRange = 0,
      // @ts-expect-error TS(2339): Property 'initialMaxPrecioRange' does not exist on...
      initialMaxPrecioRange = INITIAL_PRICE_MAX_RANGE,
      // @ts-expect-error TS(2339): Property 'onFilter' does not exist on type '{}'.
      onFilter,
      // @ts-expect-error TS(2339): Property 'showDisplayModes' does not exist on type...
      showDisplayModes = false,
      // @ts-expect-error TS(2339): Property 'onDisplayWithGridMode' does not exist on...
      onDisplayWithGridMode,
    },
    ref
  ) => {
    const { t } = useTranslation()
    const categoriasIdCached = useRef([])
    const precioLowerLimitCached = useRef(initialMinPrecioRange)
    const precioUpperLimitCached = useRef(initialMaxPrecioRange)
    const searchConceptoCached = useRef("")
    const skipCount = useRef(0)

    const [searchConcepto, setSearchConcepto] = useState("")
    const [isFirshRequest, setIsFirshRequest] = useState(true)

    const { isNearScreen } = useNearScreen({
      distance: "500px",
      externalRef: ref,
    })

    const handleOnFilter = useMemo(
      () =>
        debounce(({ withSkipCount = false } = {}) => {
          if (!withSkipCount) skipCount.current = 0

          setIsFirshRequest(false)

          return onFilter?.({
            precioVentaLowerLimit: precioLowerLimitCached.current,
            precioVentaUpperLimit: precioUpperLimitCached.current,
            categoriasId: categoriasIdCached.current || [],
            concepto: searchConceptoCached.current,
            skipCount: skipCount.current,
            maxResultCount: MAX_RESULT_COUNT,
            loadingMoreArticulos: withSkipCount,
          })
        }, 300),
      [onFilter]
    )

    useEffect(() => {
      handleOnFilter()
    }, [handleOnFilter])

    useEffect(() => {
      if (isNearScreen) {
        skipCount.current += MAX_RESULT_COUNT
        handleOnFilter({ withSkipCount: !isFirshRequest })
      }
    }, [isNearScreen, handleOnFilter, isFirshRequest])

    const handleOnChangeConcepto = (search: string) => {
      setSearchConcepto(search)
      searchConceptoCached.current = search

      handleOnFilter()
    }

    const changeSwitchBtns = ({ id }: $TSMigrationFixMe) => {
      onDisplayWithGridMode?.(id === GRID)
    }

    return (
      <>
        <div className='p-3 mt-3 wrap-articulos-filter'>
          <div
            className='pl-0 col d-flex align-items-center'
            style={{ gap: "1em" }}
          >
            <SearchInput
              placeholder={`${t("catalogos.idView.filter.placeholderSearch")}`}
              onChange={(ev: string) => {
                handleOnChangeConcepto(ev)
              }}
              inputValue={searchConcepto}
              className='tw-mb-1 sm:tw-mb-0 sm:tw-mr-2 tw-h-10 tw-w-full sm:tw-w-72'
            />

            {showDisplayModes && (
              <SwitchButtons
                btns={switchButtons(t)}
                onSelect={changeSwitchBtns}
              />
            )}
          </div>
        </div>
      </>
    )
  }
)

export default ArticulosFilter
